<script lang="ts">
	import { getSafeJsonLdScript } from '../../../../utils/getSafeJsonLdScript/getSafeJsonLdScript';

	interface Props {
		// A schema.org node (or @graph document) serialised verbatim into the page head.
		data: unknown;
	}

	let { data }: Props = $props();

	let script = $derived(getSafeJsonLdScript(data));
</script>

<svelte:head>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html script}
</svelte:head>
